import { Box, Container, Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const unlockBordersImg = "/assets/unlock-borders.webp";
const phoneScreenImg = "/assets/phone-screen.png";

const StyledHeroSection = styled(Box)(({ theme }) => ({
  background:
    "linear-gradient(180deg, var(--blue-light) 0%, var(--blue-light-transparent) 100%)",
  minHeight: "700px",
  position: "relative",
  paddingTop: theme.spacing(12),
  overflow: "hidden",
  margin: "0 auto",
}));
const StyledButton = styled(Button)(({ theme }) => ({
  background: "var(--blue-accent)",
  color: theme.palette.common.white,
  borderRadius: "100px",
  padding: theme.spacing(2, 3),
  ...theme.typography.body1,
  textTransform: "none",
  minHeight: 44,
  "&:hover": {
    background: "var(--blue-accent)",
    opacity: 0.9,
  },
}));

const PhoneMockup = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "613px",
  // aligns the image symmetrically relative to the screen on the image
  margin: "0 23% 0 26%",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0 auto",
    marginLeft: "3%",
  },
}));

const HeroContentContainer = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  maxWidth: "907px",
  textAlign: "center",
  paddingTop: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2.5),
  [theme.breakpoints.down("sm")]: {
    maxWidth: "336px",
  },
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h1,
  [theme.breakpoints.down("sm")]: {
    fontSize: "36px",
  },
}));

const HeroSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  color: theme.palette.text.primary,
  maxWidth: "600px",
  margin: "0 auto",
}));

const PhoneMockupContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  textAlign: "center",
  position: "relative",
  [theme.breakpoints.up("md")]: {
    marginTop: theme.spacing(8),
  },
}));

const HeroBackgroundImage = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: -1,
  opacity: 0.15,
  borderRadius: "50%",
  overflow: "hidden",
  display: "none",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

export default function HeroSection() {
  return (
    <StyledHeroSection>
      <Container maxWidth="lg" disableGutters>
        <HeroContentContainer>
          <HeroTitle variant="h1">
            Ваш цифровой кошелек без границ — GTC Pay
          </HeroTitle>
          <HeroSubtitle variant="h6">
            Удобные платежи, выгодные тарифы и полная финансовая мобильность по
            всему миру.
          </HeroSubtitle>
          <StyledButton
            size="large"
            onClick={() => window.open("https://uat.gtcpay.io", "_blank")}

          >
            Начать сейчас
          </StyledButton>
        </HeroContentContainer>
        <PhoneMockupContainer>
          <PhoneMockup>
            <img
              src={phoneScreenImg}
              alt="GTC Pay Mobile App"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </PhoneMockup>
          <HeroBackgroundImage>
            <img src={unlockBordersImg} alt="Unlock Borders" />
          </HeroBackgroundImage>
        </PhoneMockupContainer>
      </Container>
    </StyledHeroSection>
  );
}
